import { IUserDashboardState } from "./state";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";


export const defaultState: IUserDashboardState = {
    ordersMetrics: {
        count_and_revenue: [],
        count_by_menu_item: [], 
        count_by_category: [],
        count_by_employee: []
    },
    selectedBranchId: null
};

export const userDashboardModule = {
    state: defaultState,
    mutations,
    actions,
    getters
};